import {Component} from '@angular/core';
import {Observable} from 'rxjs';
import {SmConfirmationDialogState} from './sm-confirmation-dialog.models';
import {SmConfirmationDialogService} from './sm-confirmation-dialog.service';

@Component({
  selector: 'sm-confirmation-dialog-host',
  templateUrl: './sm-confirmation-dialog-host.component.html',
  styleUrls: ['./sm-confirmation-dialog-host.component.scss'],
  standalone: false,
})
export class SmConfirmationDialogHostComponent {
  readonly dialogState$: Observable<SmConfirmationDialogState>;

  constructor(private readonly confirmationDialogService: SmConfirmationDialogService) {
    this.dialogState$ = this.confirmationDialogService.state$;
  }

  handleCancel(): void {
    this.confirmationDialogService.cancel();
  }

  handleConfirm(textInputValue: string): void {
    void this.confirmationDialogService.confirm(textInputValue);
  }

  handleConfirmLink(event: MouseEvent): void {
    event.preventDefault();
    void this.confirmationDialogService.confirm();
  }

  handleAlternate(): void {
    this.confirmationDialogService.alternate();
  }
}
